import { HttpErrorResponse } from '@angular/common/http';

import { ExportFailureBanner } from '../../entities/downloads/export-failure.entity';

export type CreateFailureCase = 'too-large' | 'nothing-exportable' | 'rest';

export interface CreateFailure {
    readonly case: CreateFailureCase;
    readonly count?: number;
    readonly max?: number;
}

const SIDEPANEL: string = 'exports.sidepanel';

const TOO_LARGE: RegExp = /too large for a quick export\s*\((\d+)\s+dossiers?,\s*maximum\s+(\d+)\)/i;
const NOTHING_EXPORTABLE: RegExp = /resolved to no exportable records/i;

export function classifyCreateFailure(error: unknown): CreateFailure {
    if (!(error instanceof HttpErrorResponse) || error.status !== 400) {
        return { case: 'rest' };
    }

    const message: string = typeof error.error?.Message === 'string' ? error.error.Message : '';

    const tooLarge: RegExpExecArray | null = TOO_LARGE.exec(message);
    if (tooLarge) {
        return { case: 'too-large', count: Number(tooLarge[1]), max: Number(tooLarge[2]) };
    }

    if (NOTHING_EXPORTABLE.test(message)) {
        return { case: 'nothing-exportable' };
    }

    return { case: 'rest' };
}

export function toFailureToastKey(failure: CreateFailure): string {
    switch (failure.case) {
        case 'too-large':
            return 'failed-too-large';
        case 'nothing-exportable':
            return 'failed-nothing-exportable';
        default:
            return 'failed';
    }
}

export function toFailureBanner(failure: CreateFailure): ExportFailureBanner {
    switch (failure.case) {
        case 'too-large':
            return {
                titleKey: `${SIDEPANEL}.error-too-large-title`,
                textKey: `${SIDEPANEL}.error-too-large`,
                params: { count: failure.count!, max: failure.max! }
            };
        case 'nothing-exportable':
            return {
                titleKey: `${SIDEPANEL}.error-nothing-exportable-title`,
                textKey: `${SIDEPANEL}.error-nothing-exportable`,
                params: {}
            };
        default:
            return {
                titleKey: `${SIDEPANEL}.error-failed-title`,
                textKey: `${SIDEPANEL}.error-failed`,
                params: {}
            };
    }
}
